"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/helpers/ucfirst.js